/**
 * Promo code 状态徽章判定 —— PromoCardItem / LookupPanel 共享。
 *
 * 优先级：已使用(达到上限) > 停用 > 过期 > 部分使用 > 未使用
 *
 * 注意：Stripe 在 redeemed_count == max_redemptions 时会自动把
 * PromotionCode.active 置 false。所以「已使用」必须放在「停用」之前
 * 判断，否则用满的码会被错显为「停用」。
 * 注意：Stripe 不会因 expires_at 过期自动把 active 置 false，需要前端
 * 显式判断 expires_at，否则过期未用码会错显为「Unused」。
 */
import type { TFunction } from 'i18next';

export interface PromoBadge {
  color: string;
  label: string;
}

export const promoStatusBadge = (
  p: { is_active: boolean; redeemed_count: number; max_redemptions: number; expires_at?: string | null },
  t: TFunction
): PromoBadge => {
  if (p.redeemed_count >= p.max_redemptions) {
    return { color: 'blue', label: t('promotion_code.used_up') };
  }
  if (!p.is_active) return { color: 'gray', label: t('dealer.inactive') };
  if (p.expires_at && new Date(p.expires_at).getTime() < Date.now()) {
    return { color: 'red', label: t('promotion_code.status.expired') };
  }
  if (p.redeemed_count > 0) {
    return { color: 'cyan', label: t('promotion_code.partially_used') };
  }
  return { color: 'green', label: t('promotion_code.unused') };
};
